import { Platform, type TextStyle } from 'react-native';
import { colors } from './colors';

/**
 * WebKit aplica fondo claro (amarillo/blanco) a inputs con autocompletado del navegador.
 * El truco del box-shadow interior mantiene el color de fondo del tema oscuro.
 * @see https://bugs.chromium.org/p/chromium/issues/detail?id=46543
 */
export function webTextInputAutofillStyle(): TextStyle | undefined {
  if (Platform.OS !== 'web') return undefined;
  return {
    WebkitBoxShadow: `0 0 0 1000px ${colors.inputBackground} inset`,
    WebkitTextFillColor: colors.textPrimary,
    outlineStyle: 'none',
  } as unknown as TextStyle;
}
